import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { List, X } from "@phosphor-icons/react";

const links = [
  { label: "Servizi", href: "#servizi" },
  { label: "Chi Siamo", href: "#chi-siamo" },
  { label: "Lavori", href: "#lavori" },
  { label: "Contatti", href: "#contatti" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, delay: 1.9, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color] duration-500 ${
        scrolled ? "bg-white/85 backdrop-blur-xl border-b border-zinc-200" : "bg-white/40 backdrop-blur-md border-b border-transparent"
      }`}
      data-testid="main-navbar"
    >
      <nav className="max-w-7xl mx-auto flex items-center justify-between px-6 lg:px-10 h-20">
        <a href="#top" data-testid="nav-logo" className="flex items-center">
          <img src="/images/logo.png" alt="I&G Grafiche" className="h-11 w-auto" />
        </a>
        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a key={l.href} href={l.href} data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-sm text-black hover:text-[#FF007F] transition-colors duration-300 tracking-wide font-medium">
              {l.label}
            </a>
          ))}
          <a href="#contatti" data-testid="nav-cta-quote"
            className="text-sm font-semibold px-5 py-2.5 rounded-full bg-gradient-to-r from-[#00E5FF] to-[#FF007F] text-black hover:opacity-90 hover:scale-[1.03] transition-[opacity,transform] duration-300">
            Richiedi un Preventivo
          </a>
        </div>
        <button className="md:hidden text-zinc-900 p-2" data-testid="nav-mobile-toggle" onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <X size={26} /> : <List size={26} />}
        </button>
      </nav>
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35 }}
            className="md:hidden overflow-hidden bg-white/95 backdrop-blur-xl border-b border-zinc-200"
            data-testid="nav-mobile-menu"
          >
            <div className="flex flex-col px-6 py-6 gap-5">
              {links.map((l) => (
                <a key={l.href} href={l.href} onClick={() => setOpen(false)}
                  data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                  className="text-lg font-display text-black">
                  {l.label}
                </a>
              ))}
              <a href="#contatti" onClick={() => setOpen(false)} data-testid="nav-mobile-cta-quote"
                className="text-center font-semibold px-5 py-3 rounded-full bg-gradient-to-r from-[#00E5FF] to-[#FF007F] text-black">
                Richiedi un Preventivo
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
